import { render, staticRenderFns } from "./DistributionAmountsTable.vue?vue&type=template&id=d25e17ac&scoped=true&"
import script from "./DistributionAmountsTable.vue?vue&type=script&lang=js&"
export * from "./DistributionAmountsTable.vue?vue&type=script&lang=js&"
import style0 from "./DistributionAmountsTable.vue?vue&type=style&index=0&id=d25e17ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25e17ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VFileInput,VForm,VSimpleTable,VTextField})
